import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useSelector, useDispatch } from 'react-redux';
import { Zoom } from '@mui/material';
import SelectorGrid from './SelectorGrid';

import '../../css/jb-styles.css';

import {
  isReviewing,
  registeredPattern,
  resetPattern,
  selectedCell,
} from '../../../redux/challengeSlice';

export default function CreateGrid() {
  const theme = useTheme();

  const registeredPatternState = useSelector((state) => state.challenge.registeredPattern);

  const [pattern, setPattern] = useState(registeredPatternState);
  const [patternCount, setPatternCount] = useState(0);
  const [numberOfDigits, setNumberOfDigits] = useState(0);
  const [reviewing, setReviewing] = useState(false);

  const dispatch = useDispatch();

  let array0 = new Array(6).fill(null);
  let gridArray = [array0, array0, array0, array0, array0, array0];

  const createCellClassName = (rowIndex, columnIndex) => {
    let cellClassName = '';

    switch (rowIndex) {
      case 0:
      case 5:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      case 1:
      case 4:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          case 1:
          case 4:
          case 2:
          case 3:
            cellClassName = 'jb-border-400';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      case 2:
      case 3:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          case 1:
          case 4:
            cellClassName = 'jb-border-400';
            break;
          case 2:
          case 3:
            cellClassName = 'jb-border-300';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      default:
        cellClassName = 'jb-border-200';
    }

    return cellClassName;
  }

  const clickCell = (row, col) => {

    // console.log('In click handler)');
    // console.log('pattern.length: ', pattern.length);

    // if (pattern.length == 6) {
    //   // limit the length of the pattern to 6 digits
    //   return;
    // }

    // if (patternCount == 6) {
    //   return;
    // }

    if (pattern.length == 6) {
      return;
    }

    // console.log('In click);')

    let tmp = document.getElementById(`cell-${row}-${col}`);
    if (tmp.classList.contains('digits-4')) {
      alert('You can only select the same cell upto 4 times');
      return;
    }

    let tmpArray = [...pattern];
    tmpArray.push([row, col, pattern.length + 1]);
    setPattern(tmpArray);
  }

  const cellClasses = (cell) => {
    if (cell.classList.contains('digits-0')) {
      cell.classList.replace('digits-0', 'digits-1');
      setNumberOfDigits(1);
      cell.style.fontSize = '1em';
      cell.style.color = '#3B4E68';
    } else if (cell.classList.contains('digits-1')) {
      cell.classList.replace('digits-1', 'digits-2');
      setNumberOfDigits(2);
      cell.style.fontSize = '1em';
      cell.style.color = '#3B4E68';
    } else if (cell.classList.contains('digits-2')) {
      cell.classList.replace('digits-2', 'digits-3');
      setNumberOfDigits(3);
      cell.style.fontSize = '1em';
      cell.style.color = '#3B4E68';
    } else if (cell.classList.contains('digits-3')) {
      cell.classList.replace('digits-3', 'digits-4');
      setNumberOfDigits(4);
      cell.style.fontSize = '1em';
      cell.style.color = '#3B4E68';
    };
  };

  useEffect(() => {

    dispatch(registeredPattern(pattern));
    // console.log('useEffect - Pattern: ', pattern);

    setPatternCount(pattern.length);

    if (pattern.length == 0) {

    } else {

      let cell = document.getElementById(`cell-${pattern[pattern.length - 1][0]}-${pattern[pattern.length - 1][1]}`);
      cell.style.border = '3px solid #3B4E68';
      cell.style.backgroundColor = '#FFFFFF';
      // Assign classes based on number of digits
      cellClasses(cell);
    }

  }, [pattern]);

  useEffect(() => {
    // console.log('patternCount: ', patternCount);
  }, [patternCount]);

  useEffect(() => {
    // console.log('numberOfDigits: ', numberOfDigits);
  }, [numberOfDigits]);

  useEffect(() => {
    // console.log('registeredPatternState: ', registeredPatternState);
  }, [registeredPatternState]);

  useEffect(() => {
    console.log('reviewing: ', reviewing);
    if (reviewing === true) {
      dispatch(isReviewing(true));
      console.log('reviewing: ', reviewing);
    } else {
      dispatch(isReviewing(false));
      console.log('reviewing: ', reviewing);
    }
  }, [reviewing]);

  useEffect(() => {
    resetStyling();
  }, []);

  const reset = () => {
    dispatch(resetPattern());
    dispatch(selectedCell(null));
    setPatternCount(0);
    setPattern([]);
    resetStyling();
  };

  const resetStyling = () => {
    // console.log('In resetStyling');
    for (let i = 0; i < 6; i++) {
      for (let j = 0; j < 6; j++) {
        resetCellStyles(i, j);
        let cell = document.getElementById(`cell-${i}-${j}`);
        if (cell.classList.contains('digits-1')) {
          cell.classList.replace('digits-1', 'digits-0');
        } else if (cell.classList.contains('digits-2')) {
          cell.classList.replace('digits-2', 'digits-0');
        } else if (cell.classList.contains('digits-3')) {
          cell.classList.replace('digits-3', 'digits-0');
        } else if (cell.classList.contains('digits-4')) {
          cell.classList.replace('digits-4', 'digits-0');
        }
        setNumberOfDigits(0);
      }
    }
  };

  const resetCellStyles = (rowIndex, columnIndex) => {
    // let cellClassName = '';

    let cell = document.getElementById(`cell-${rowIndex}-${columnIndex}`);

    switch (rowIndex) {
      case 0:
      case 5:
        switch (columnIndex) {
          case 0:
          case 5:
            // cellClassName = 'jb-border-200';
            cell.style.borderColor = 'rgb(229 231 235)';
            cell.style.backgroundColor = 'rgb(229 231 235)';
            break;
          default:
            // cellClassName = 'jb-border-200';
            cell.style.borderColor = 'rgb(229 231 235)';
            cell.style.backgroundColor = 'rgb(229 231 235)'
        }
        break;
      case 1:
      case 4:
        switch (columnIndex) {
          case 0:
          case 5:
            // cellClassName = 'jb-border-200';
            cell.style.borderColor = 'rgb(229 231 235)';
            cell.style.backgroundColor = 'rgb(229 231 235)'
            break;
          case 1:
          case 4:
          case 2:
          case 3:
            // cellClassName = 'jb-border-400';
            cell.style.borderColor = 'rgb(156 163 175)';
            cell.style.backgroundColor = 'rgb(156 163 175)'
            break;
          default:
            // cellClassName = 'jb-border-200';
            cell.style.borderColor = 'rgb(229 231 235)';
            cell.style.backgroundColor = 'rgb(229 231 235)'
        }
        break;
      case 2:
      case 3:
        switch (columnIndex) {
          case 0:
          case 5:
            // cellClassName = 'jb-border-200';
            cell.style.borderColor = 'rgb(229 231 235)';
            cell.style.backgroundColor = 'rgb(229 231 235)'
            break;
          case 1:
          case 4:
            // cellClassName = 'jb-border-400';
            cell.style.borderColor = 'rgb(156 163 175)';
            cell.style.backgroundColor = 'rgb(156 163 175)'
            break;
          case 2:
          case 3:
            // cellClassName = 'jb-border-300';
            cell.style.borderColor = 'rgb(209 213 219)';
            cell.style.backgroundColor = 'rgb(209 213 219)'
            break;
          default:
            // cellClassName = 'jb-border-200';
            cell.style.borderColor = 'rgb(229 231 235)';
            cell.style.backgroundColor = 'rgb(229 231 235)'
        }
        break;
      default:
        // cellClassName = 'jb-border-200';
        cell.style.borderColor = 'rgb(229 231 235)';
        cell.style.backgroundColor = 'rgb(229 231 235)'
    }

    // return cellClassName;
  }



  const review = () => {
    setReviewing(true);
    let tmpPattern = registeredPatternState;
    setPatternCount(0);
    dispatch(registeredPattern([]));
    setPattern([]);
    resetStyling();

    var tmpArray = [];
    do_timeout(tmpPattern, (cell) => {
      tmpArray = [...tmpArray, cell];
      setPattern(tmpArray);
    }, 1000, 0);
    // setReviewing(false);
  };

  function do_timeout(tmpPattern, callback = () => { }, delay = 1000, index = 0) {
    if (index < tmpPattern.length) {
      setTimeout(function () {
        callback(tmpPattern[index]);
        do_timeout(tmpPattern, callback, delay, ++index);
      }, delay);
    }

    if (index == tmpPattern.length) {
      setReviewing(false);
    }
  };

  return (

    <React.Fragment>
      <SelectorGrid review={reviewing} />
      <Box>

        <Box
          id='vauth-swipe-grid-container'
          sx={{
            padding: '20px',
            paddingTop: '10px',
            paddingBottom: 0,
            width: '100%',
            alignSelf: 'center',
            cursor: `url('/sites/default/files/media/image/circle2.svg'), auto`,
          }}
        >

          {gridArray.map((row, rowIndex) => (
            <Box
              key={`grid-row${rowIndex}`}
              id={`grid-row${rowIndex}`}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
              }}>
              {row.map((cell, columnIndex) => (
                <Box
                  key={`grid-column${columnIndex}`}
                  id={`cell-${rowIndex}-${columnIndex}`}
                  className={`card jb-cell digits-0 ${createCellClassName(rowIndex, columnIndex)}`}
                  sx={{
                    width: '15%',
                    aspectRatio: '1 / 1',
                    color: '#3B4E68',
                  }}
                  onClick={() => { clickCell(rowIndex, columnIndex); }}
                >
                  <Cell digits={numberOfDigits} row={rowIndex} col={columnIndex} />

                </Box>
              ))}
            </Box>
          ))
          }

        </Box >

        <Box
          sx={{
            paddingTop: '10px',
          }}
        >
          <Typography variant='body1'
            sx={{
              fontSize: '0.7em',
              color: '#3B4E68',
            }}>
            Choose a pairing cell from the top row
            then draw your pattern on the grid.
          </Typography>
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '20px',
            paddingRight: '20px',
            paddingLeft: '20px',
            paddingBottom: '20px',
            // paddingTop: '10px',
            borderBottom: '2px solid #3B4E68',
          }}>
          Choose a pairing cell from the top row
          then draw your pattern on the grid.
        </Typography> */}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          margin: '20px',
          paddingRight: '20px',
          paddingLeft: '20px',
          paddingBottom: '20px',
          // paddingTop: '10px',
          borderBottom: '2px solid #3B4E68',
        }}>
        <Box
          sx={{
            width: '45%',
          }}
        >
          <Button
            // variant="contained"
            // sx={{
            //   width: '100%',
            //   backgroundColor: '#3B4E68',
            //   border: '1px solid #3B4E68',
            //   color: '#FFFFFF',
            //   '&:hover': {
            //     color: '#3B4E68',
            //     border: '1px solid #3B4E68',
            //     backgroundColor: '#60A5FA',
            //   }
            // }}
            variant="outlined"
            sx={{
              width: '100%',
              color: '#3B4E68',
              border: '1px solid #3B4E68',
              backgroundColor: '#FFFFFF',
              '&:hover': {
                color: '#FFFFFF',
                backgroundColor: '#3B4E68',
              }
            }}
            // disabled={true}
            onClick={review}
          >
            Review
          </Button>
        </Box>
        {/* <Box
            sx={{
              width: '45%',
            }}
          >
            <Button
              variant="contained"
              sx={{
                width: '100%',
                backgroundColor: '#3B4E68',
                border: '1px solid #3B4E68',
                color: '#FFFFFF',
                '&:hover': {
                  color: '#3B4E68',
                  border: '1px solid #3B4E68',
                  // backgroundColor: '#FFFFFF',
                  backgroundColor: '#60A5FA',
                }
              }}
              onClick={reset}
            // disabled={true}
            onClick={review}
          >
            Review
          </Button>
        </Box> */}
        <Box
          sx={{
            width: '45%',
          }}
        >
          <Button
            // variant="contained"
            // sx={{
            //   width: '100%',
            //   backgroundColor: '#3B4E68',
            //   border: '1px solid #3B4E68',
            //   color: '#FFFFFF',
            //   '&:hover': {
            //     color: '#3B4E68',
            //     border: '1px solid #3B4E68',
            //     backgroundColor: '#60A5FA',
            //   }
            // }}
            variant="outlined"
            sx={{
              width: '100%',
              color: '#3B4E68',
              border: '1px solid #3B4E68',
              backgroundColor: '#FFFFFF',
              '&:hover': {
                color: '#FFFFFF',
                backgroundColor: '#3B4E68',
              }
            }}
            onClick={reset}
          // disabled={true}
          >
            Reset
          </Button>
        </Box>

      </Box>
    </React.Fragment>
  );
};

const digitStyle0 = {
  display: 'flex',
  alignItems: 'center',
};

const digitStyle1 = {
  // color: 'purple',
};

const digitStyle1A = {
  // color: 'purple',
};

const digitStyle2 = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
};

const digitStyle2A = {
  height: '50%',
  // height: '30%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.7em',
};

const digitStyle2B = {
  height: '50%',
  // height: '30%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.7em',
};

const digitStyle3 = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

const digitStyle3BC = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '50%',
  justifyContent: 'space-around',
  alignItems: 'center',
};

const digitStyle3A = {
  height: '50%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.7em',
  justifyContent: 'center',
};

const digitStyle3B = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.7em',
};

const digitStyle3C = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.7em',
};

const digitStyle4 = {
  // color: 'blue',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

const digitStyle4BC = {
  // color: 'green',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '30%',
  justifyContent: 'space-around',
  alignItems: 'center',
};

const digitStyle4A = {
  // color: 'blue',
  fontSize: '0.6em',
  height: '30%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const digitStyle4B = {
  // color: 'blue',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.6em',
};

const digitStyle4C = {
  // color: 'blue',
  fontSize: '0.6em',
};

const digitStyle4D = {
  // color: 'purple',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.6em',
  justifyContent: 'center',
  height: '30%',
};

function Cell(props) {

  const [count, setCount] = useState(0);

  let tmp = document.getElementById(`cell-${props.row}-${props.col}`);

  const registeredPatternState = useSelector((state) => state.challenge.registeredPattern);





  if (tmp === null) {
    return (
      <Box
        sx={digitStyle0}
      >
        <FiberManualRecordIcon />
      </Box>
    );
  } else if (tmp.classList.contains('digits-0')) {
    return (
      <Box
        sx={digitStyle0}
      >
        <FiberManualRecordIcon />
      </Box>
    );
  } else if (tmp.classList.contains('digits-1')) {

    let digitArray1 = [];
    registeredPatternState.map((cell, index) => {
      if (cell[0] == props.row && cell[1] == props.col) {
        digitArray1.push(cell)
      }

    });

    return (

      <Box
        sx={digitStyle1}
      >
        <Box
          sx={digitStyle1A}
        >
          {digitArray1[0][2]}
        </Box>
      </Box>

    );

  } else if (tmp.classList.contains('digits-2')) {

    let digitArray2 = [];
    registeredPatternState.map((cell, index) => {
      if (cell[0] == props.row && cell[1] == props.col) {
        digitArray2.push(cell)
      }
    });

    return (

      <Box
        sx={digitStyle2}
      >
        <Box
          sx={digitStyle2A}
        >
          {digitArray2[0][2]}
        </Box>
        <Box
          sx={digitStyle2B}
        >
          {digitArray2[1][2]}
        </Box>
      </Box>

    );




  } else if (tmp.classList.contains('digits-3')) {
    let digitArray3 = [];
    registeredPatternState.map((cell, index) => {
      if (cell[0] == props.row && cell[1] == props.col) {
        digitArray3.push(cell)
      }
    });

    return (


      <Box
        sx={digitStyle3}
      >
        <Box
          sx={digitStyle3A}
        >
          {digitArray3[0][2]}
        </Box>
        <Box
          sx={digitStyle3BC}
        >
          <Box
            sx={digitStyle3B}
          >
            {digitArray3[1][2]}
          </Box>
          <Box
            sx={digitStyle3C}
          >
            {digitArray3[2][2]}
          </Box>
        </Box>
      </Box>

    );
  } else if (tmp.classList.contains('digits-4')) {
    let digitArray4 = [];
    registeredPatternState.map((cell, index) => {
      if (cell[0] == props.row && cell[1] == props.col) {
        digitArray4.push(cell)
      }
    });

    return (

      <Box
        sx={digitStyle4}
      >
        <Box
          sx={digitStyle4A}
        >
          {digitArray4[0][2]}
        </Box>
        <Box
          sx={digitStyle4BC}
        >
          <Box
            sx={digitStyle4B}
          >
            {digitArray4[1][2]}
          </Box>
          <Box
            sx={digitStyle4C}
          >
            {digitArray4[2][2]}
          </Box>
        </Box>
        <Box
          sx={digitStyle4D}
        >
          {digitArray4[3][2]}
        </Box>
      </Box>

    );
  }
}